import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button } from 'reactstrap'
import { message } from 'antd'

import { updateFaq } from '../services'
import { handleError } from '../../../helpers'

export default function FaqContentWidget({ faq }) {
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: {
			question: faq.question,
			answer: faq.answer
		}
	})

	const onSubmit = values => {
		updateFaq(faq.id, values)
			.then(res => message.success(res.data.message))
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Form.Group>
					<Form.Control 
						{...register('question', { required:true })}
						placeholder="Escriba aquí la pregunta"
					/>
					{ errors.question && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Form.Group>
					<Form.Control 
						as="textarea"
						{...register('answer', { required:true })}
						placeholder="Escriba aquí la respuesta"
						style={{ height: '150px' }}
					/>
					{ errors.answer && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Button outline color='primary' type='submit'>Actualizar Datos</Button>
			</Form>
		</React.Fragment>
	)
}